import { CohortDslLegacy, IndexDateVariableLegacy } from '@verantos-dev/types-cohorts';
import {
  getFullDslQueryString,
  transformIndexDateToDsl,
} from '@verantos-dev/util-cohort-definition-ui-to-dsl';

export const getFullCohortDslForIndexDate = (
  indexDateValue?: IndexDateVariableLegacy,
  currentCohortDsl?: CohortDslLegacy
) => {
  const newCohortDsl: CohortDslLegacy = {
    inclusionCriteria: currentCohortDsl?.inclusionCriteria ?? [],
    exclusionCriteria: currentCohortDsl?.exclusionCriteria ?? [],
    studyPeriodRestrictions: currentCohortDsl?.studyPeriodRestrictions ?? [],
    subjectVariables: currentCohortDsl?.subjectVariables ?? [],
    indexDate: indexDateValue ? transformIndexDateToDsl(indexDateValue) : undefined,
    simpleEvents: currentCohortDsl?.simpleEvents ?? [],
    derivedEvents: currentCohortDsl?.derivedEvents ?? [],
  };
  return getFullDslQueryString(newCohortDsl);
};
